import { type ReactElement } from 'react';

import { IntegrationSection } from '@/components/integrations/IntegrationSection';
import { PersonalSlackIntegration } from '@/components/integrations/PersonalSlackIntegration';

export function PersonalIntegrationsSubTab(): ReactElement {
  return (
    <div data-testid="integrations-sections" className="flex flex-col gap-7">
      <IntegrationSection
        title="Notifications"
        subtitle="Configure Slack notifications for your personal scan alerts"
      >
        <PersonalSlackIntegration />
      </IntegrationSection>
    </div>
  );
}

PersonalIntegrationsSubTab.displayName = 'PersonalIntegrationsSubTab';
